import React from 'react';
import classNames from 'classnames';

import { Counter } from '@/components';
import { NOT_DEFINED } from '@/constants';

import {
  getDefaultProductInfoComponents,
  ProductActionFavorite,
  ProductBadgeContainer,
  ProductImage,
  ProductInfoCarousel,
  ProductLinkWrapper,
  ProductName,
  ProductPrice,
  ProductVariants,
} from '../Product.components';

import style from '../product.module.scss';
import styleVariation from './ProductCardBtnBottomHover.module.scss';
import { ProductVariationProps } from '../Product';
import { useProductContext } from '../context';

const ProductCardBtnBottomHover: React.FC<ProductVariationProps> = ({
  className,
  analyticsListName,
  isLargeCard,
}) => {
  const { product, isSpecial, variants, weightVariant, compoundList } =
    useProductContext();

  const availableInfo = getDefaultProductInfoComponents(product, compoundList);

  return (
    <ProductLinkWrapper
      analyticsListName={analyticsListName}
      className={classNames(style.product, styleVariation.product, className)}
      isInternalWrapper
      product={product}
    >
      <div className={styleVariation.product__image_container}>
        <ProductImage
          className={styleVariation.product__image}
          product={product}
        />
        <div className={styleVariation.actions__body}>
          <ProductActionFavorite
            className={classNames(
              style.favorite_action,
              styleVariation.favorite__button,
            )}
            product={product}
          />
        </div>
        <ProductBadgeContainer
          className={styleVariation.product__badges_container}
          product={product}
          weightVariant={weightVariant}
        />
      </div>
      <div
        className={classNames(
          style.product__body,
          styleVariation.product__body,
        )}
      >
        <ProductName name={product?.name || NOT_DEFINED} />
        <ProductInfoCarousel
          className={styleVariation.variation__info_carousel}
        >
          {availableInfo}
        </ProductInfoCarousel>
        <div
          className={classNames(styleVariation.product__actions_footer, {
            [styleVariation.product__actions_footer_largue_card]: isLargeCard,
          })}
        >
          <ProductPrice
            className={styleVariation.product__price}
            elementVariants={<ProductVariants />}
            isOverflow={variants?.length === 1}
            isSpecial={isSpecial}
            type="column-container"
            weightVariant={weightVariant}
          />
          <Counter
            actionTheme="primary"
            className={classNames(styleVariation.actions__counter_hover, {
              [styleVariation.actions__counter_hover_largue_card]: isLargeCard,
            })}
            onCard
            product={product}
            selectedWeightVariant={weightVariant}
            showIcon
          />
        </div>
      </div>
    </ProductLinkWrapper>
  );
};

export { ProductCardBtnBottomHover };
